import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { MembersShell } from "@/components/members/MembersShell";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated/membros")({
  beforeLoad: async () => {
    const { data: userRes } = await supabase.auth.getUser();
    if (!userRes.user) throw redirect({ to: "/auth" });
    const { data } = await supabase.rpc("has_active_entitlement", {
      _user_id: userRes.user.id,
      _product_slug: "101-negocios-reais",
    });
    if (!data) {
      throw redirect({ to: "/no-access" as never });
    }
  },
  component: () => (
    <MembersShell>
      <Outlet />
    </MembersShell>
  ),
});
